











import { Watch, Prop, Component, Vue } from 'vue-property-decorator'

@Component
export default class InputSwitch extends Vue {
    @Prop({ type: Boolean, default: false }) readonly disabled!: boolean
    @Prop({ default: null }) readonly rules!: string
    @Prop() readonly name!: string
    @Prop() readonly label!: string
    @Prop({ type: Boolean, default: false }) readonly value!: boolean
    internalValue: boolean = null

    created() {
        this.onExternalChange()
    }

    transformInput(value: boolean) {
        if (value === null) {
            value = false
        }

        return value
    }

    transformOutput(value: boolean) {
        return value
    }

    @Watch('value')
    onExternalChange() {
        this.internalValue = this.transformInput(this.value)

        if (this.internalValue === null) {
            this.internalValue = false
        }
    }

    @Watch('internalValue')
    onInternalChange() {
        const value = this.transformOutput(this.internalValue)
        if (value !== this.value) {
            this.$emit('input', value)
        }
    }

    onInput(): void {
        this.$emit('input', this.internalValue)
    }

    get componentClass(): object {
        return {
            'input-switch': true,
            'input-switch--disabled': this.disabled,
        }
    }
}
